import UserSession from '@app/common/user-session';

const Headers = (function() {
  const getAuthHeaders = function() {
    const token = UserSession.getToken();
    return {
      'Accept': 'application/json',
      'Authorization': `Bearer ${token}`
    }
  };

  const getPublicHeaders = function() {
    return {
      'Accept': 'application/json'
    }
  };

  return {
    getAuthHeaders: getAuthHeaders,
    getPublicHeaders: getPublicHeaders
  }

})();

export default Headers;
